/** Query callback OAuth gian hàng: ?ketQua=thanh-cong|loi&thongBao=... */

export type BanOnlineOauthKetQua = {
  thanhCong: boolean
  thongBao: string
}

export function docBanOnlineOauthKetQua(
  search: string,
): BanOnlineOauthKetQua | null {
  const q = new URLSearchParams(search.startsWith('?') ? search : `?${search}`)
  const ketQua = q.get('ketQua')
  if (!ketQua) return null
  if (ketQua === 'thanh-cong') {
    return {
      thanhCong: true,
      thongBao: 'Kết nối gian hàng thành công — hệ thống đang kéo đơn về',
    }
  }
  return {
    thanhCong: false,
    thongBao: q.get('thongBao') || 'Kết nối gian hàng thất bại',
  }
}

/** Xóa ketQua/thongBao khỏi query, giữ param khác. */
export function xoaBanOnlineOauthQuery(search: string): string {
  const q = new URLSearchParams(search.startsWith('?') ? search : `?${search}`)
  q.delete('ketQua')
  q.delete('thongBao')
  const s = q.toString()
  return s ? `?${s}` : ''
}
